import { HighlightStyle, syntaxHighlighting } from "@codemirror/language";
import { EditorView } from "@codemirror/view";

import colorTokens from "shared/helpers/colors";

import { tags } from "./mode";

const textColor = "#eff";
const background = "#2d2d2d";
const highlightBackground = "transparent";
const tooltipBackground = "#fff";
const selectionBackground = "rgba(128,203,196,0.2)";
const cursorColor = "#fc0";
const gutterColor = "#596d79";
const panelColor = "#b0b0b0";
const searchBackground = "#B9D2FF";
const searchColor = "#000";

export const editorTheme = EditorView.theme(
  {
    "&": {
      color: textColor,
      backgroundColor: background,
    },

    ".cm-content": {
      caretColor: cursorColor,
    },

    "&.cm-editor.cm-focused": {
      outline: "none",
    },

    ".cm-cursor, .cm-dropCursor": { borderLeftColor: cursorColor },
    "&.cm-focused .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection":
      {
        backgroundColor: `${selectionBackground} !important`,
      },

    ".cm-panels": { backgroundColor: background, color: panelColor },
    ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
    ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },

    ".cm-searchMatch": {
      backgroundColor: searchBackground,
      color: searchColor,
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
      backgroundColor: searchBackground,
      color: searchColor,
    },

    ".cm-activeLine": { backgroundColor: highlightBackground },
    ".cm-selectionMatch": { backgroundColor: highlightBackground },

    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      outline: `1px solid ${panelColor}`,
    },

    "&.cm-focused .cm-matchingBracket": {
      backgroundColor: "transparent",
      outline: "none",
    },

    ".cm-gutters": {
      borderRight: "1px solid #ffffff10",
      color: gutterColor,
      backgroundColor: background,
    },

    ".cm-activeLineGutter": {
      backgroundColor: highlightBackground,
    },

    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: searchBackground,
    },

    ".cm-matchingBracket": {
      backgroundColor: "#c08b51 !important",
    },

    ".cm-tooltip": {
      border: "none",
      backgroundColor: tooltipBackground,
      color: "black",
      borderRadius: "3px",
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent",
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: tooltipBackground,
      borderBottomColor: tooltipBackground,
    },
    ".cm-tooltip-autocomplete": {
      "& .cm-completionIcon": {
        display: "none",
      },
      "& .cm-completionDetail": {
        fontSize: "10px",
        fontStyle: "normal",
      },
      "&.cm-tooltip > ul > li": {
        padding: "4px",
        fontFamily: "Roboto",

        "&:hover": {
          background: colorTokens["ds-denim-9"],
          color: tooltipBackground,
        },
      },
      "& > ul > li[aria-selected]": {
        background: colorTokens["ds-denim-8"],
      },
    },
  },
  { dark: true }
);

export const booleanHighlightStyle = HighlightStyle.define([
  { tag: tags.field, color: colorTokens["ds-blue-4"] },
  { tag: tags.and, color: colorTokens["ds-yellow-2"] },
  { tag: tags.or, color: colorTokens["ds-darkblue-4"] },
  { tag: [tags.not, tags.unless], color: colorTokens["ds-red-4"] },
  {
    tag: [tags.near, tags.atleast, tags.first],
    color: colorTokens["ds-purple-4"],
  },
  { tag: tags.quotes, color: colorTokens["ds-green-2"] },
  { tag: tags.brackets, color: "#f7d994" },
  { tag: tags.comment, color: "#546E7A" },
  { tag: tags["query-snippet"], color: colorTokens.social },
]);

export const theme = [editorTheme, syntaxHighlighting(booleanHighlightStyle)];
